// extracted by mini-css-extract-plugin
export default {"options":"Options_options__ZWIxv","single":"Options_single__WdAAb","option":"Options_option__+cpYH","inactive":"Options_inactive__NkIiQ"};